const awsmobile = {
   "aws_project_region": "us-east-2",
   "aws_cognito_identity_pool_id": "us-east-2:cb45a0f0-06d6-4bb2-a0b0-26984e910535",
   "aws_cognito_region": "us-east-2",
   "aws_user_pools_id": "us-east-2_qEscjVC2N",
   "aws_user_pools_web_client_id": "28hbkr8nihs9qf2ufnaaco8ite"
}
export default awsmobile;
